import React from 'react'
import { useIntl } from 'react-intl'

import FeaturesFooter from '@/components/sections/FeaturesFooter'
import { Layout } from '@/components/layout'
import FeaturePageHeader from '@/components/sections/FeaturePageHeader'
import IntegrationsTabs from '@/components/sections/IntegrationsTabs/IntegrationsTabs'
import IntegrationsHeroImg from '@/assets/integrations/integrations-hero.png'

import styles from './integrations.module.scss'

const pageId = 'integrations'
export default function IntegrationsPage() {
  const { formatMessage } = useIntl()
  const getPageMessage = (id) => formatMessage({ id: `pages.${pageId}.${id}` })

  return (
    <Layout.Content>
      <FeaturePageHeader
        description={getPageMessage('main.description')}
        heroProps={{
          src: IntegrationsHeroImg,
          alt: 'integrations-hero',
          maxWidth: 600,
          style: { height: 'auto' },
        }}
        subtitle={getPageMessage('main.subtitle')}
        title={getPageMessage('main.title')}
      />

      <IntegrationsTabs />
      <FeaturesFooter
        header="pages.integrations.main.ctaHeader"
        sectionProps={{ className: styles.footerSection }}
        textContent="pages.integrations.main.ctaText"
      />
    </Layout.Content>
  )
}

IntegrationsPage.layoutProps = {
  pageId,
}
